import React, { memo, useCallback, useState } from 'react'

import { Slider, TextInput } from '@cgtrader/triangle-ui/dist/src/ssr-index'

import useTranslation from 'Pods/ThreeDStudio/Hooks/useTranslation'
import InfoIconTooltip from 'Pods/ThreeDStudio/Shared/InfoIconTooltip/InfoIconTooltip'
import { useThreeDStudioStore } from 'Pods/ThreeDStudio/Store'
import { setStyleStrength } from 'Pods/ThreeDStudio/Store/actions/renderSettings'

const MIN = 0
const MAX = 1
const STEP = 0.1

const clamp = value => Math.min(MAX, Math.max(MIN, value))

function StyleStrengthField() {
  const t = useTranslation()
  const styleStrength = useThreeDStudioStore(state => state.renderSettings.styleStrength)
  const hasStyle = useThreeDStudioStore(state => state.renderSettings.styles.length > 0)
  // The raw text while typing, so partial decimals like "0." are not reformatted
  // mid-keystroke. Dropped on blur, when the field snaps back to the stored value.
  const [draft, setDraft] = useState(null)

  const handleInputChange = useCallback((event) => {
    const { value } = event.target
    setDraft(value)

    const numValue = Number.parseFloat(value)
    if (!Number.isNaN(numValue)) {
      setStyleStrength(clamp(numValue))
    }
  }, [])

  const handleInputBlur = useCallback(() => {
    setDraft(null)
  }, [])

  if (!hasStyle) {
    return null
  }

  const label = t('viewerSidebar.enhance.render.styleStrengthLabel')

  return (
    <div className="render-tab__field">
      <span className="render-tab__label-row">
        <label className="render-tab__label cgt-body-base-semibold" htmlFor="render-style-strength">
          {label}
        </label>
        <InfoIconTooltip
          id="render-style-strength-tooltip"
          content={t('viewerSidebar.enhance.render.styleStrengthTooltip')}
          label={label}
          triggerClassName="render-tab__info"
        />
      </span>
      <div className="render-tab__slider-row">
        <Slider
          hideRangeValues
          min={MIN}
          max={MAX}
          step={STEP}
          value={styleStrength}
          onChange={setStyleStrength}
          wrapperClassName="render-tab__slider"
        />
        <TextInput
          id="render-style-strength"
          isPilot
          size="small"
          value={draft ?? styleStrength}
          onChange={handleInputChange}
          onBlur={handleInputBlur}
          textInputClassName="render-tab__slider-input"
        />
      </div>
    </div>
  )
}

export default memo(StyleStrengthField)
